import type { ChangeEvent, FC } from 'react';

type DnaSliderProps = {
  value: number;
  onChange: (value: number) => void;
  leftLabel: string;
  leftDescription: string;
  rightLabel: string;
  rightDescription: string;
  caption: string;
  ticks?: string[];
  max?: number;
  disabled?: boolean;
};

const DnaSlider: FC<DnaSliderProps> = ({
  value,
  onChange,
  leftLabel,
  leftDescription,
  rightLabel,
  rightDescription,
  caption,
  ticks,
  max = 5,
  disabled = false,
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(Number(event.target.value));
  };

  return (
    <div className="w-full">
      <div className="flex items-end justify-between gap-6 text-left">
        <div>
          <p className="font-feature text-2xl font-semibold text-[var(--cream)]">
            {leftLabel}
          </p>

          <p className="font-sans text-sm text-[var(--cream-3)]">
            {leftDescription}
          </p>
        </div>

        <div className="text-right">
          <p className="font-feature text-2xl font-semibold text-[var(--cream)]">
            {rightLabel}
          </p>

          <p className="font-sans text-sm text-[var(--cream-3)]">
            {rightDescription}
          </p>
        </div>
      </div>

      <input
        type="range"
        min={1}
        max={max}
        step={1}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        className="dna-range mt-8 w-full cursor-pointer accent-[var(--gold)] disabled:cursor-not-allowed disabled:opacity-60"
      />

      {ticks?.length ? (
        <div
          className="mt-4 grid font-feature text-lg text-[var(--gold)]"
          style={{
            gridTemplateColumns: `repeat(${ticks.length}, minmax(0, 1fr))`,
          }}
        >
          {ticks.map((tick) => (
            <span key={tick} className="text-center">
              {tick}
            </span>
          ))}
        </div>
      ) : null}

      <p className="mt-7 text-center font-sans text-base text-[var(--gold-deep)]">
        {caption}
      </p>
    </div>
  );
};

export default DnaSlider;